export const filterFieldForDomain = {
    registers: 'searchField',
    discountRegisters: 'searchField',
};
